import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {Game} from '@/app/core/models/game';
import {Achievement} from '@/app/core/models/achievement';
import {RosterType} from '@/app/core/models/rosterType';

@Injectable({
	providedIn: 'root'
})
export class AchievementService {

	constructor(
		private readonly http: HttpClient
	) {}

	getAllAchievementByRosterType(rosterType: RosterType): Observable<Achievement[]> {
		return this.http.get<Achievement[]>(`${environment.backendUrl}/achievement/roster/${rosterType}`);
	}

}
